/**
 * Component: Video Player
 * ------------------------------------------------------------------------------
 * Component to control the video player.
 *
 * @namespace videoPlayer
 */
import Plyr from 'plyr';
import { icons } from '~/layout/styleguide/utils/icon-map';
/**
 * DOM selectors.
 */

const selectors = {
  videoPlayer: '[js-video-player="video"]'
};
const attributes = {
  title: 'js-video-player-title'
};
/**
 * Set cached node selectors.
 */

const nodeSelectors = {
  videoPlayer: document.querySelector(selectors.videoPlayer)
};
export default (() => {
  /**
   * Builds video title html for wider screen
   */
  function buildDesktopTitleHtml() {
    const title = document.querySelector(selectors.videoPlayer).getAttribute(attributes.title);

    if (title) {
      return "\n        <div class=\"video-player__row\">\n          <h1 class=\"video-player__title-desktop\">".concat(title, "</h1>\n        </div>");
    }

    return "";
  }
  /**
   * Builds video controls html
   */


  function buildVideoControlsHtml() {
    const playPause = "\n      <button type=\"button\" class=\"plyr__control\" aria-label=\"Play\" data-plyr=\"play\">\n        <span class=\"plyr__control-component\">\n          <svg class=\"icon--pressed\" role=\"presentation\"><use xlink:href=\"#plyr-pause\"></use></svg>\n          <svg class=\"icon--not-pressed\" role=\"presentation\"><use xlink:href=\"#plyr-play\"></use></svg>\n        </span>\n        <span class=\"plyr__control-component\">\n          <span class=\"label--pressed\">Pause</span>\n          <span class=\"label--not-pressed\">Play</span>\n        </span>\n      </button>\n    ";
    const volume = "\n      <div class=\"plyr__volume\">\n        <input data-plyr=\"volume\" type=\"hidden\" min=\"0\" max=\"1\" step=\"0.05\" value=\"1\" autocomplete=\"off\" aria-label=\"Volume\" aria-valuenow=\"45\" aria-valuetext=\"45.0%\" style=\"--value:45%; \">\n        \n        <button type=\"button\" class=\"plyr__control\" aria-label=\"Mute\" data-plyr=\"mute\">\n          <svg class=\"icon--pressed\" role=\"presentation\"><use xlink:href=\"#plyr-muted\"></use></svg>\n          <svg class=\"icon--not-pressed\" role=\"presentation\"><use xlink:href=\"#plyr-volume\"></use></svg>\n        \n          <span class=\"label--pressed plyr__tooltip\" role=\"tooltip\">Unmute</span>\n          <span class=\"label--not-pressed plyr__tooltip\" role=\"tooltip\">Mute</span>\n        </button>\n      </div>\n    ";
    const progress = "\n      <div class=\"plyr__progress\">\n        <input data-plyr=\"seek\" type=\"range\" min=\"0\" max=\"100\" step=\"0.01\" value=\"0\" aria-label=\"Seek\" aria-valuemax=\"0\" aria-valuenow=\"0\" aria-valuetext=\"00:00 of 00:00\" style=\"--value:0%;\" seek-value=\"0\">\n        <progress class=\"plyr__progress__buffer\" min=\"0\" max=\"100\" value=\"0\">% buffered</progress>\n        <span role=\"tooltip\" class=\"plyr__tooltip\" style=\"left: 19.175%;\">00:05</span>\n      </div>\n    ";
    const bigPlayButton = "\n      <button type=\"button\" class=\"plyr__control plyr__control--overlaid plyr__control--pressed\" data-plyr=\"play\" aria-label=\"Pause\">\n        ".concat(icons.videoPlay, "\n        <span class=\"plyr__sr-only\">Play</span>\n      </button>\n    ");
    return "\n      ".concat(bigPlayButton, "\n      <div class=\"plyr__controls\">\n        ").concat(buildDesktopTitleHtml(), "\n        <div class=\"video-player__row\">\n          ").concat(playPause, "\n          ").concat(volume, "\n        </div>\n        <div class=\"video-player__footer\">\n          ").concat(progress, "\n        </div>\n      </div>\n      ");
  }
  /**
   * Instantiate events on video player.
   */


  function init() {
    if (!nodeSelectors.videoPlayer) {
      return;
    }

    const controls = buildVideoControlsHtml();
    new Plyr(nodeSelectors.videoPlayer, {
      controls
    });
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});